import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy thông tin giấy phép đăng ký kinh doanh theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Object|null>} - Thông tin giấy phép đầu tiên hoặc null
 */
export const getBusinessLicenseByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.BUSINESS_LICENSES.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data) && data.data.length > 0) {
            return data.data[0];
        }

        return null;
    } catch (error) {
        console.error("Lỗi khi lấy thông tin giấy phép kinh doanh:", error);
        return null;
    }
};
